<template>
  <div>
    <!-- 添加 -->
    <template>
      <Modal v-model="visible" title="添加部门" draggable class-name="vertical-center-modal" ok-text="添加" width="730" height="300"
        style="overflow: hidden;" @on-ok="ok" @on-cancel="cancel" :loading="loading">
        <Form ref="details" :model="details" :rules="ruleValidate" label-position="right" :label-width="100" style="width: 714px; height: 400px; margin: 0 auto; overflow-y: auto; padding-top: 20px;">

          <Row span="24">
            <Col span="10" v-if="IsSuperAdmin == '1'">
              <FormItem label="选择集团" prop="GroupCode">
                <Select v-model="details.GroupCode" @on-change="onChange">
                  <Option v-for="item in groupList" :key="item.Id" :value="item.GroupCode">{{item.GroupName}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem label="选择公司" prop="CompanyCode">
                <Select v-model="details.CompanyCode">
                  <Option v-for="item in companyList" :key="item.Id" :value="item.CompanyCode">{{item.CompanyName}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>

          <Row span="24">
            <Col span="10">
              <FormItem label="部门编号" prop="DepartmentCode">
                <Input v-model="details.DepartmentCode" placeholder="请输入部门编号"></Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem label="部门名称" prop="DepartmentName">
                <Input v-model="details.DepartmentName" placeholder="请输入部门名称"></Input>
              </FormItem>
            </Col>
          </Row>

        </Form>
      </Modal>
    </template>
  </div>
</template>

<script>
import { GetGrouplists, GetCompanyLists } from "@/api/url_api.js";
import Cookies from "js-cookie";
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      details: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        visible: false,
        formLeft: {},
        loading: true,

        groupList: [],
        companyList: [],

        groupCode1: Cookies.get('GroupCode'),
        IsSuperAdmin: Cookies.get('IsSuperAdmin'),

        ruleValidate: {
          GroupCode: [{ required: true, message: '请选择集团', trigger: 'change' }],
          CompanyCode: [{ required: true, message: '请选择公司', trigger: 'change' }],
          DepartmentCode: [{ required: true, message: '部门编号不能为空', trigger: 'blur' }],
          DepartmentName: [{ required: true, message: '部门名称不能为空', trigger: 'blur' }]
        }
      }
    },
    watch: {
      isShow(newValue, old) {
        this.visible = newValue;
        if (this.visible) {
          if (this.IsSuperAdmin == '1') {
            // 获取集团列表（不带分页）
            this.getGrouplists();
          } else {
            this.getCompanyLists(this.groupCode1);
          } 
        }
      }
    },
    mounted() {

    },
    methods: {

      // 获取集团列表（不带分页）
      getGrouplists() {
        let _this = this;
        GetGrouplists().then(res => {
          if (res.Success) {
            _this.groupList = res.Data;
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // 根据id获取公司
      onChange(value) {
        let _this = this;
        _this.getCompanyLists(value);
      },

      // 获取公司列表不带分页
      getCompanyLists(id) {
        let _this = this;
        GetCompanyLists(`?groupCode=${id}`).then(res => {
          if (res.Success) {
            if (_this.IsSuperAdmin == '1') {
              _this.details.CompanyCode = '';
            }            
            _this.companyList = res.Data;
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      ok(value) {
        let _this = this;
        _this.$refs.details.validate(valid => {
            if (valid) {
                if (_this.IsSuperAdmin == '0') {
                  _this.details.GroupCode = _this.groupCode1;
                }
                _this.$emit("on-change", false, _this.details);
            } else {
                _this.$Message.error("请输入必填项");
                _this.loading = false;
                _this.$nextTick(() => {
                    _this.loading = true;
                });
            }
        });

      },
      cancel(value) {
        this.$emit("on-change", this.visible)
      }
    },
  }
</script>

<style scoped="scoped">

</style>
